import { useGame, useLobbyGame } from "~/app";
import { getLobbyGameParams } from "~/business";
import { XTechTile } from "../design";
import { Spacing } from "~/jsx/theme";

export const XTechPanel = () => {
  const lobbyGame = useLobbyGame();
  const { useIxExtension = false } = getLobbyGameParams(lobbyGame) ?? {};
  if (!useIxExtension) return null;
  const { game } = useGame();
  const { techTiles } = game;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: Spacing.px8,
      }}
    >
      {techTiles.map((techPile) => {
        const topTile = techPile.last();
        if (topTile) {
          return <XTechTile key={topTile.id} techTile={topTile} />;
        } else {
          return null;
        }
      })}
    </div>
  );
};
